
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Components/Login/login';
import Profile from './Components/Profile/profile';
import { AuthProvider } from './Components/Contexts/authContext';
import HistoricalWithdraw from './Components/Historical_withdraw/historical_withraw';
import RegisterForm from './Components/Register/register';
import MainScreen from './Components/Main_screen/main_screen';
import ProtectedRoute from './Components/Contexts/ProtectedRoute';
import ResetPasswordForm from './Components/Reset Password/reset_password';
import ChangePassword from './Components/Reset Password/change_password';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes> 
          <Route path="/" element={<Login />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/historical_withdraw" element={<HistoricalWithdraw />} />
          <Route path="/register"  element={<ProtectedRoute element={RegisterForm} allowedRoles={['admin']} />} />
          <Route path="/main" element={<MainScreen />} />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/change-password" element={<ChangePassword />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
